<!--
 * @Author: lwk
 * @Date: 2024-01-24 14:03:22
 * @LastEditors: lwk
 * @LastEditTime: 2024-03-06 17:12:38
 * @Description: 请填写简介
-->
<template>
  <div>
    <div class="timeRadio">
      <el-date-picker
              v-model="dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              size="mini"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
              :clearable="false"
              @change="selectTimeRange"
            >
            </el-date-picker>
      <el-radio-group v-model="radioTime" size="mini" @input="changeDate">
        <el-radio-button label="yesterDay">昨日</el-radio-button>
        <el-radio-button label="week">近一周</el-radio-button>
      </el-radio-group>
    </div>
    <div id="echartsId"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import { getDepartmentManagerData } from "@/api/doOneGood";
export default {
  name: "ManagerLike",
  data() {
    return {
      radioTime: "yesterDay",
      startTime: "",
      endTime: "",
      sourceData:[],
      myChart:'',
      dateRange:[]
    };
  },
  mounted() {
    setTimeout(() => {
      this.initEcharts();
      this.changeDate("yesterDay");
    }, 500);
  },
  methods: {
    initEcharts() {
      var chartDom = document.getElementById("echartsId");
      var chartsOption = {
        title: {
          text: "经理人点评点赞排名"
        },
        legend: {
          // right: 100,
          // top: 20,
          textStyle: {
            align: 'center'   // 水平对齐方式为居中
        }
        },
        tooltip: {},
        grid: {
          left: "3%",
          right: "4%",
          bottom: "1%",
          containLabel: true
        },
        dataset: {
          dimensions: ['product', '点评', '点赞'],
          source: this.sourceData
        },
        xAxis: { type: "category" },
        yAxis: {name: "（得分）"},
        // Declare several bar series, each will be mapped
        // to a column of dataset.source by default.
        series: [{ 
            type: "bar" ,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#83bff6" },
                { offset: 0.5, color: "#188df0" },
                { offset: 1, color: "#188df0" }
              ])
            }
    }, { 
        type: "bar",
        itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: "#cfe8d5" },
                { offset: 0.5, color: "#55b74f" },
                { offset: 1, color: "#3c6e3f" }
              ])
            }
     }]
      };
      this.myChart = echarts.init(chartDom);
      chartsOption && this.myChart.setOption(chartsOption);
    },
    async changeDate(val) {
      switch (val) {
        case "yesterDay":
          this.startTime = moment()
            .subtract(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .subtract(1, "days")
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          break;
        case "week":
          this.startTime = moment()
            .startOf("week")
            .format("YYYY-MM-DD HH:mm:ss");
          this.endTime = moment()
            .endOf("week")
            .format("YYYY-MM-DD HH:mm:ss");
            
          break;

        default:
          break;
      }
      this.dateRange = [this.startTime, this.endTime]
      this.getEchartData()
    },
    async getEchartData() {
      const params = {
        startTime: this.startTime,
        endTime: this.endTime
      };
      const { code, data } = await getDepartmentManagerData(params);
      if (code != "0") return;
          this.sourceData = data.map(item => {
            return [item.employeeName,item.dp,item.dz]
          })
      this.myChart.setOption({
        dataset:{
          source: this.sourceData
        }
      });
    },
    selectTimeRange(val) {
      this.startTime = val[0]
      this.endTime = val[1]
      this.getEchartData()
    }
  }
};
</script>

<style>
#echartsId {
  width: 100%;
  height: 260px;
}
.timeRadio {
  position: absolute;
  margin-top: 15px;
  z-index: 999;
  right: 6%;
}
</style>



// WEBPACK FOOTER //
// src/components/OneGoodModule/ManagerLike.vue